// Extracted from sections/ov-navbar.liquid (perf lot 1). Classic script loaded with defer.
(function () {
  var mega = document.getElementById('ov-mega-menu');
  var trigger = document.getElementById('ov-collections-trigger');
  var chevron = document.getElementById('ov-collections-chevron');
  var burger = document.getElementById('ov-burger');
  var btnClose = document.getElementById('ov-drawer-close');
  var drawer = document.getElementById('ov-drawer');
  var overlay = document.getElementById('ov-overlay');
  var iconB = document.getElementById('ov-icon-burger');
  var iconX = document.getElementById('ov-icon-close');
  var closeTimer;

  // --- Méga menu desktop ---
  if (trigger && mega) {
    // Le panneau est declare apres le logo et les icones dans le markup : tel
    // quel, Tab depuis le trigger part sur le lien de nav suivant et le menu
    // est inatteignable au clavier. On le replace derriere son trigger. Le
    // bloc englobant reste .ov-hdr-bar, donc le rendu ne bouge pas.
    if (trigger.parentNode) trigger.parentNode.insertBefore(mega, trigger.nextSibling);
    var megaOverlay = document.getElementById('ov-mega-overlay');

    function openMega() {
      clearTimeout(closeTimer);
      if (megaOverlay) {
        megaOverlay.style.display = 'block';
        requestAnimationFrame(function () { megaOverlay.classList.add('is-visible'); });
      }
      mega.style.display = '';
      requestAnimationFrame(function () {
        mega.style.visibility = 'visible';
        mega.style.opacity = '1';
      });
      trigger.setAttribute('aria-expanded', 'true');
      if (chevron) { chevron.style.transform = 'rotate(180deg)'; chevron.style.opacity = '1'; }
    }
    function closeMega() {
      closeTimer = setTimeout(function () {
        if (megaOverlay) {
          megaOverlay.classList.remove('is-visible');
          setTimeout(function () {
            if (!megaOverlay.classList.contains('is-visible')) megaOverlay.style.display = 'none';
          }, 200);
        }
        // Le panneau repart toujours sur la grille : sinon il se rouvre sur la
        // derniere promo survolee, sans rapport avec l'intention du clic.
        if (typeof showView === 'function') showView(defaultView);
        mega.style.opacity = '0';
        mega.style.visibility = 'hidden';
        setTimeout(function () { if (mega.style.opacity === '0') mega.style.display = 'none'; }, 150);
        trigger.setAttribute('aria-expanded', 'false');
        if (chevron) { chevron.style.transform = ''; chevron.style.opacity = '0.5'; }
      }, 120);
    }
    // Le focus qui passe du trigger vers un lien du panneau ne doit pas le
    // fermer, sinon le menu est inatteignable au clavier.
    function leavesMenu(e) {
      var next = e.relatedTarget;
      return !next || (next !== trigger && !mega.contains(next));
    }
    var openedByHover = false;
    // --- Vues de la zone droite ---
    var views = mega.querySelectorAll('[data-mm-panel]');
    var qlinks = mega.querySelectorAll('[data-mm-view]');
    var rail = mega.querySelector('.ov-mm__quick');
    var defaultView = (rail && rail.getAttribute('data-mm-default')) || 'grid';

    function showView(id) {
      Array.prototype.forEach.call(views, function (v) {
        v.hidden = v.getAttribute('data-mm-panel') !== id;
      });
      Array.prototype.forEach.call(qlinks, function (l) {
        l.classList.toggle('is-active', l.getAttribute('data-mm-view') === id);
      });
    }

    Array.prototype.forEach.call(qlinks, function (l) {
      var id = l.getAttribute('data-mm-view');
      l.addEventListener('mouseenter', function () { showView(id); });
      l.addEventListener('focus', function () { showView(id); });
    });
    // Le focus d'un lien a panneau masque la grille : Tab depuis le dernier
    // lien sautait alors les cartes. La grille revient avant que le focus ne
    // parte, le lien suivant reprend sa vue a son propre focus.
    if (rail) {
      rail.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' && !e.shiftKey) showView('grid');
      });
    }

    trigger.addEventListener('mouseenter', function () {
      if (trigger.getAttribute('aria-expanded') !== 'true') openedByHover = true;
      openMega();
    });
    trigger.addEventListener('mouseleave', closeMega);
    // Echap ferme puis rend le focus au trigger : sans ce garde-fou, le focus
    // rouvre aussitot le panneau et Echap n'a aucun effet visible.
    var dismissed = false;
    trigger.addEventListener('focus', function () { if (!dismissed) openMega(); });
    trigger.addEventListener('blur', function (e) { if (leavesMenu(e)) closeMega(); });
    mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', closeMega);
    mega.addEventListener('focusin', function () { clearTimeout(closeTimer); });
    mega.addEventListener('focusout', function (e) { if (leavesMenu(e)) closeMega(); });
    // Le pointeur ouvre deja au survol : sans ce garde-fou, le clic qui suit
    // ce survol refermerait aussitot le panneau.
    trigger.addEventListener('click', function () {
      if (openedByHover) { openedByHover = false; return; }
      trigger.getAttribute('aria-expanded') === 'true' ? closeMega() : openMega();
    });
    // Clic hors zone : le panneau se ferme sans rendre le focus au trigger.
    document.addEventListener('click', function (e) {
      if (trigger.getAttribute('aria-expanded') !== 'true') return;
      if (trigger.contains(e.target) || mega.contains(e.target)) return;
      openedByHover = false;
      closeMega();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        dismissed = true;
        closeMega();
        trigger.focus();
        setTimeout(function () { dismissed = false; }, 0);
      }
    });
  }

  // --- Drawer mobile ---
  var lastFocused = null;
  var inerted = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  // Le reste de la page passe inerte : sans ca, Tab sort du drawer et le
  // lecteur d'ecran annonce le contenu masque derriere l'overlay.
  function deactivateBackground() {
    inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === drawer || el === overlay || el.contains(drawer)) return;
      if (el.hasAttribute('inert') || el.getAttribute('aria-hidden') === 'true') return;
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
      inerted.push(el);
    });
  }
  function reactivateBackground() {
    inerted.forEach(function (el) {
      el.removeAttribute('inert');
      el.removeAttribute('aria-hidden');
    });
    inerted = [];
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    // Compenser la scrollbar avant de la supprimer, sinon la page saute de sa
    // largeur au moment ou overflow:hidden tombe.
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.body.style.overflow = 'hidden';

    drawer.style.display = 'flex';
    void drawer.offsetWidth;
    drawer.style.transform = 'translateX(0)';
    overlay.style.display = 'block';
    burger && burger.setAttribute('aria-expanded', 'true');
    if (iconB) iconB.classList.add('ov-hidden');
    if (iconX) iconX.classList.remove('ov-hidden');
    deactivateBackground();
    btnClose && btnClose.focus();
  }

  function closeDrawer() {
    drawer.style.transform = 'translateX(-100%)';
    overlay.style.display = 'none';
    burger && burger.setAttribute('aria-expanded', 'false');
    if (iconB) iconB.classList.remove('ov-hidden');
    if (iconX) iconX.classList.add('ov-hidden');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    reactivateBackground();
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
    drawer.addEventListener('transitionend', function onEnd() {
      drawer.removeEventListener('transitionend', onEnd);
      if (drawer.style.transform === 'translateX(-100%)') drawer.style.display = 'none';
    });
    // prefers-reduced-motion coupe la transition : pas de transitionend, on
    // referme donc aussi sur un delai de secours.
    setTimeout(function () {
      if (drawer.style.transform === 'translateX(-100%)') drawer.style.display = 'none';
    }, 350);
  }

  function drawerIsOpen() {
    return drawer.style.display !== 'none' && drawer.style.display !== '';
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (btnClose) btnClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (!drawerIsOpen()) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Fermeture au swipe vers la gauche.
  var touchX = null;
  drawer.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
  drawer.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (dx < -60) closeDrawer();
  }, { passive: true });

  // --- Accordeons ---
  // L'etat initial vient du serveur (panneau ouvert = classe --open, hauteur
  // auto) : rien ne "saute" au chargement, le JS ne fait qu'animer ensuite.
  document.querySelectorAll('[data-acc]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('data-acc'));
    if (!panel) return;
    var sign = btn.querySelector('.ov-dw-acc__sign');

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      panel.classList.remove('ov-dw-acc__panel--open');
      if (isOpen) {
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.height = '0px';
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        panel.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          // Hauteur auto une fois ouvert : le carrousel peut grandir sans
          // rester coupe par la hauteur figee de l'animation.
          if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        });
      }
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (sign) sign.innerHTML = isOpen ? '+' : '&minus;';
    });
  });

})();
